import React, { useState } from 'react';
import '../SpeedDial.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Paper, InputBase, Tabs, Tab, Box } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { getAvatarUrl } from '../../../utils/getAvatarUrl';


function TabPanel({ children, value, index }) {
    return <div hidden={value !== index}>{value === index && <Box sx={{ mt: 2 }}>{children}</Box>}</div>;
}

export default function MembersModal({
    handleMembersDialogClose,
    searchTerm,
    handleSearchChange,
    filteredMembers,
    boardMembers,
    selectedMembers,
    handleCheckboxChange,
    CustomCheckbox,
    handleSaveChanges,
    handleRemoveChanges,
    username
}) {
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newValue) => setTabIndex(newValue);

    return (
        <div >
            <Dialog
                open={true}
                onClose={handleMembersDialogClose}
                maxWidth="sm"
                fullWidth
                BackdropProps={{
                    sx: {
                        backdropFilter: 'blur(5px)',
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    }
                }}
                PaperProps={{
                    sx: {
                        maxHeight: '600px',
                        minHeight: '700px',
                        width: '600px',
                        m: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }
                }}
            >
                <DialogTitle
                    className='text-navbar-options'
                    sx={{ textAlign: 'center', fontSize: '23px', fontWeight: 700, paddingBottom: '10px' }}>
                    Gerenciar Membros
                </DialogTitle>
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    centered
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#009373',
                            height: 2,
                            top: 20,
                        },
                    }}
                >
                    <Tab
                        label="Adicionar"
                        sx={{
                            minHeight: 0,
                            padding: '0 15px',
                            color: '#666',
                            '&.Mui-selected': {
                                color: '#009373',
                            },
                        }}
                    />
                    <Tab
                        label="Remover"
                        sx={{
                            minHeight: 0,
                            padding: '0 15px',
                            color: '#666',
                            '&.Mui-selected': {
                                color: '#009373',
                            },
                        }}
                    />
                </Tabs>

                <DialogContent

                    sx={{
                        paddingTop: '5px',
                    }}
                >
                    <TabPanel value={tabIndex} index={0}>
                        <Typography
                            className='text-navbar-options'
                            sx={{ fontSize: '17px', mb: 2 }}>Convide um membro para seu quadro</Typography>
                        <Paper
                            className='textfield-dark'
                            sx={{ p: '5px 4px', display: 'flex', alignItems: 'center', mb: 2,}}>
                            <InputBase
                                
                                sx={{ ml: 1, width: '100%', }}
                                placeholder="Buscar membros"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </Paper>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography
                                className='text-navbar-options'
                                sx={{ fontSize: '15px', mt: 3 }}>Membros participantes do time:</Typography>
                            <Typography
                                onClick={handleSaveChanges}
                                className='button-navbar-options'
                                sx={{
                                    fontSize: '13x',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '150px !important',
                                    padding: '0 !important',
                                }}
                            >
                                Salvar alterações
                            </Typography>
                        </Box>
                        <ul style={{ padding: 0 }}>
                            {filteredMembers.map((member) => {
                                const isMemberInBoard = boardMembers.some((bm) => bm.user_id === member.userId);
                                if (!isMemberInBoard) {
                                    const isSelected = selectedMembers.includes(member.userId);
                                    return (
                                        <li key={member.userId} style={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <div className='text-navbar-options' style={{ display: 'flex', alignItems: 'center' }}>
                                                <Avatar src={getAvatarUrl(member.Nome)} sx={{ width: 30, height: 30, mt: 0.5 }} />
                                                <span style={{ marginLeft: 10, fontSize: 14 }}>{member.nome_completo}</span>
                                            </div>
                                            <CustomCheckbox
                                                value={member.userId}
                                                checked={isSelected}
                                                onChange={(e) => handleCheckboxChange(member.userId, e.target.checked)}
                                            />
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </ul>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={1}>
                        <Typography className='text-navbar-options' sx={{ fontSize: '17px', mb: 2 }}>Remova um membro do seu quadro</Typography>
                        <Paper 
                        className='textfield-dark'
                        sx={{ p: '5px 4px', display: 'flex', alignItems: 'center', mb: 2, }}>
                            <InputBase
                                sx={{ ml: 1, width: '100%'}}
                                placeholder="Buscar membros"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </Paper>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography
                                className='text-navbar-options'
                                sx={{ fontSize: '15px', mt: 3 }}>Membros disponíveis para remoção:</Typography>
                            <Typography
                                className='button-navbar-options'
                                onClick={handleRemoveChanges}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '150px !important',
                                    padding: '0 !important',
                                }}
                            >
                                Salvar alterações
                            </Typography>
                        </Box>
                        <ul style={{ padding: 0 }}>
                            {filteredMembers.map((member) => {
                                const isMemberInBoard = boardMembers.some((bm) => parseInt(bm.user_id) === parseInt(member.userId));
                                const isSelected = selectedMembers.includes(member.userId);
                                if (member.Nome !== username && isMemberInBoard) {
                                    return (
                                        <li key={member.userId} style={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <div className='text-navbar-options' style={{ display: 'flex', alignItems: 'center' }}>
                                                <Avatar src={getAvatarUrl(member.Nome)} sx={{ width: 30, height: 30, mt: 0.5 }} />
                                                <span style={{ marginLeft: 10, fontSize: 14 }}>{member.nome_completo}</span>
                                            </div>
                                            <CustomCheckbox
                                                value={member.userId}
                                                checked={isSelected}
                                                onChange={(e) => handleCheckboxChange(member.userId, e.target.checked)}
                                            />
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </ul>
                    </TabPanel>
                </DialogContent>
                <DialogActions>
          <Button
            onClick={handleMembersDialogClose}
            style={{
              textTransform: "none",
              border: "none",
              borderRadius: "6px",
              padding: "10px",
              width: "100px",
              cursor: "pointer",
              height: "40px",
            }}
            className="button-navbar-options"
          >
            Fechar
          </Button>
        </DialogActions>
            </Dialog>
        </div>
    );
}
